export type Provider = "claude" | "codex";

export interface UsageWindow {
  limitId: string;
  durationMinutes: number;
  usedPercent: number | null;
  resetsAt: number | null;
}

export interface QuotaSlot {
  durationMinutes: 300 | 10_080;
  label: "5 小时用量" | "7 天用量";
  window: UsageWindow | null;
}

const QUOTA_SLOTS = [
  { durationMinutes: 300, label: "5 小时用量" },
  { durationMinutes: 10_080, label: "7 天用量" },
] as const;

export function selectQuotaWindow(provider: Provider, windows: UsageWindow[], durationMinutes: number): UsageWindow | null {
  const matches = windows.filter((window) => window.durationMinutes === durationMinutes);
  if (provider === "codex" && matches.length > 0) {
    const preferred = matches.find((window) => window.limitId === "codex:primary")
      ?? matches.find((window) => window.limitId.startsWith("codex:"))
      ?? matches.find((window) => window.limitId.startsWith("codex_") && window.limitId.endsWith(":primary"));
    if (preferred) return preferred;
  }
  if (matches[0]) return matches[0];
  const expectedId = durationMinutes === 300 ? "five_hour" : "seven_day";
  return windows.find((window) => window.limitId === expectedId) ?? null;
}

export function quotaSlots(provider: Provider, windows: UsageWindow[]): QuotaSlot[] {
  return QUOTA_SLOTS.map((slot) => ({ ...slot, window: selectQuotaWindow(provider, windows, slot.durationMinutes) }));
}

export function resetText(resetsAt: number | null, nowMillis = Date.now()): string {
  if (resetsAt === null) return "重置时间未知";
  const remaining = resetsAt * 1000 - nowMillis;
  if (remaining < 60_000) return "等待刷新";
  const totalMinutes = Math.floor(remaining / 60_000);
  const days = Math.floor(totalMinutes / 1_440);
  const hours = Math.floor(totalMinutes / 60) % 24;
  const minutes = totalMinutes % 60;
  if (days > 0) return `还剩 ${days}天${hours.toString().padStart(2, "0")}小时`;
  if (hours > 0) return `还剩 ${hours}小时${minutes.toString().padStart(2, "0")}分`;
  return `还剩 ${minutes}分`;
}

export function quotaHistoryDetail(provider: Provider, windows: UsageWindow[]): string {
  return quotaSlots(provider, windows)
    .filter((slot) => slot.window !== null)
    .map((slot) => `${slot.label.replace("用量", "")} ${slot.window?.usedPercent ?? "—"}%`)
    .join(" · ") || "额度快照为空";
}

export function quotaSourceLabel(source: string): string {
  if (source === "official_statusline") return "官方 claude -p /usage";
  if (source === "official_app_server") return "官方 app-server";
  return source;
}
